export default [
  {
    path: "list",
    name: "users-list",
    component: () => import("@/views/users/views/list/UsersList.vue"),
    meta: {
      pageTitle: "users",
      breadcrumb: [
        {
          text: "LIST",
        },
      ],
      section: 4,
    },
  },
  {
    path: "register",
    name: "user-register",
    component: () => import("@/views/users/views/list/UserRegister.vue"),
    meta: {
      section: 4,
      pageTitle: "create user",
      breadcrumb: [
        {
          text: "register",
        },
      ],
    },
  },
  {
    path: "edit/:id",
    name: "user-edit",
    component: () => import("@/views/users/views/list/UserRegister.vue"),
    meta: {
      section: 4,
      pageTitle: "edit user",
      breadcrumb: [
        {
          text: "edit",
        },
      ],
    },
  },
];
